import { mergeClasses } from '@blank/utilities'
import { Skeleton, SkeletonProps } from '../Skeleton/Skeleton'

export const HeadingSkeleton = ({ className, ...props }: SkeletonProps) => {
  return <Skeleton className={mergeClasses('h-8 w-48', className)} {...props} />
}
